import React, { FC } from "react";
import { BatchStatus } from "../../services/dashboard/dashboard.types";
import EventCount from "./EventCount";
import EventProgressBar from "./EventProgressBar";
import FailedAlert from "./FailedAlert";
import { SideDrawerLink, BatchStatusRow } from "./MoaDashboard.styles";

interface BatchStatusProps {
  name: string;
  batchStatus?: BatchStatus;
  openDetailsDrawer?: () => void;
  openFailedDrawer: () => void;
  isLoading?: boolean
}

const BatchStatusDisplay: FC<BatchStatusProps> = (
    {
      name,
      batchStatus,
      openDetailsDrawer,
      openFailedDrawer,
      isLoading
    }
) => {
  return (
      <>
        {!!batchStatus && batchStatus.total !== 0 &&
          <BatchStatusRow>
            {isLoading || batchStatus.total === batchStatus.processed
                ? <EventCount
                    label={`${name}`} //TODO: Check if 'translated' needs to be re-added
                    count={batchStatus.total}
                    isLoading={isLoading ?? false}
                    testId={`batchEventsCounter`}
                />
                : <EventProgressBar
                    name={name}
                    processed={batchStatus.processed}
                    total={batchStatus.total}
                />
            }
            {batchStatus.failed > 0
                ? <FailedAlert
                    count={batchStatus.failed}
                    openDrawer={openFailedDrawer}
                    id={name}
                />
                : !!openDetailsDrawer &&
              <SideDrawerLink
                label={`See details`}
                to={''}
                onClick={openDetailsDrawer}
              />
            }
          </BatchStatusRow>
        }
      </>
  )
}

export default BatchStatusDisplay;